import { render } from "./ChamarDemandaProjeto.vue?vue&type=template&id=3deb9880&scoped=true"
import script from "./ChamarDemandaProjeto.vue?vue&type=script&lang=js"
export * from "./ChamarDemandaProjeto.vue?vue&type=script&lang=js"

import "./ChamarDemandaProjeto.vue?vue&type=style&index=0&id=3deb9880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3deb9880"]])

export default __exports__